import type { CardIid, PlayerView } from '@sw/engine';
import type { GameViewMessage } from '@sw/protocol';
import { create } from 'zustand';

export type UiAction = 'build' | 'wonder' | 'discard';

interface GameState {
  gameId: string | null;
  stateVersion: number;
  view: PlayerView | null;
  /** UI local de selección (no confirmada). */
  selectedCard: CardIid | null;
  action: UiAction | null;
  paymentIndex: number;
  sending: boolean;
  setView(msg: GameViewMessage): void;
  clear(): void;
  selectCard(card: CardIid | null): void;
  setAction(a: UiAction | null): void;
  setPaymentIndex(i: number): void;
  setSending(b: boolean): void;
}

export const useGame = create<GameState>((set) => ({
  gameId: null,
  stateVersion: -1,
  view: null,
  selectedCard: null,
  action: null,
  paymentIndex: 0,
  sending: false,
  setView(msg) {
    set((s) => {
      if (s.gameId === msg.gameId && msg.stateVersion < s.stateVersion) return s;
      const decisionChanged = !s.view || s.view.decisionId !== msg.view.decisionId || s.gameId !== msg.gameId;
      return {
        gameId: msg.gameId,
        stateVersion: msg.stateVersion,
        view: msg.view,
        ...(decisionChanged ? { selectedCard: null, action: null, paymentIndex: 0, sending: false } : {}),
      };
    });
  },
  clear() {
    set({ gameId: null, stateVersion: -1, view: null, selectedCard: null, action: null, paymentIndex: 0, sending: false });
  },
  selectCard(selectedCard) {
    set({ selectedCard, action: null, paymentIndex: 0 });
  },
  setAction(action) {
    set({ action, paymentIndex: 0 });
  },
  setPaymentIndex(paymentIndex) {
    set({ paymentIndex });
  },
  setSending(sending) {
    set({ sending });
  },
}));
